import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 0 2rem;

  > h2 {
    font-weight: bold;
  }
`;

export const FooterButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  > button {
    max-width: 200px;
  }
`;

// Components to insides Sections
export const HeaderSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1rem;
`;

export const HeaderText = styled.h4`
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
`;

